import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterOutlet } from '@angular/router';
import { MatSidenavContainer, MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { MatToolbar } from '@angular/material/toolbar';
import { MatNavList, MatListItem } from '@angular/material/list';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-chart-side-nav',
    templateUrl: './chart-side-nav.component.html',
    styleUrls: ['./chart-side-nav.component.scss'],
    imports: [MatSidenavContainer, MatSidenav, MatToolbar, MatNavList, MatListItem, RouterLink, MatSidenavContent, MatIconButton, MatIcon, RouterOutlet]
})
export class ChartSideNavComponent implements OnInit {
  public plant: string
  public plantSub: any

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.plant = this.route.firstChild.snapshot.params["plant"]
  }

  ngOnDestroy(){

  }

}
